import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { Add } from '@mui/icons-material'
import moment from 'moment/moment'

import { Divider } from '@mui/material'
import { UPLOAD_FILE_TYPE } from 'utils/constants/config'
import generateOptions from '../generateOptions'
import { columns } from './columns'
import { OPERATION_MESSAGES } from "../../../utils/constants/operations"
import { getOccupationAreas } from "../../../services/apiKYE"
import OccupationAreaFormDialog from "./OccupationAreaForm"
import FileManagerConfig from '../FileManagerConfig'
import EditBaseHeader from '../EditBaseHeader'

const OccupationAreaConfig = () => {
  const token = useSelector((state) => state.auth.access_token)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [isEditorDialogOpen, setIsEditorDialogOpen] = useState(false)
  const [selectedOccupationArea, setSelectedOccupationArea] = useState(null)

  const handleAdd = () => {
    setIsEditorDialogOpen(true)
  }

  function handleEdit(occupationArea) {
    setSelectedOccupationArea(occupationArea)
    setIsEditorDialogOpen(true)
  }

  const actions = [
    {
      icon: Add,
      callback: handleAdd,
      tooltip_text: 'Adicionar novo registro',
    },
  ]

  const filename = `areas-${moment().format(
    'DD_MM_YYYY_HH_mm_ss',
  )}`

  const options = generateOptions(filename, actions)

  const loadData = async () => {
    setLoading(true)

    try {
      return await getOccupationAreas(token, {})
    } catch (error) {
      console.error(error)
      toast.error(OPERATION_MESSAGES.LOAD_DATA_FAIL)
      return null
    } finally {
      setLoading(false)
    }
  }

  const initializeDataState = async () => {
    try {
      const responseData = await loadData()

      if (responseData?.length > 0) {
        const transformedData = responseData.map((row) => ({
          ...row,
          actions: {
            edit: () => handleEdit(row),
          },
        }))

        setData(transformedData)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClose = () => {
    setIsEditorDialogOpen(false)
    setSelectedOccupationArea(null)
    initializeDataState()
  }

  useEffect(() => {
    initializeDataState()
  }, [])

  return (
    <div>

      <FileManagerConfig fileType={UPLOAD_FILE_TYPE.occupation_areas_file} baseItemsCount={data?.length} loadingBase={loading} />

      <Divider />

      <EditBaseHeader />

      {loading ? (
        <TableLoadingAnimation />
      ) : data.length > 0 ? (
        <MUIDataTable data={data} columns={columns} options={options} />
      ) : (
        <NotFoundMessage />
      )}
      <OccupationAreaFormDialog
        open={isEditorDialogOpen}
        occupation_area={selectedOccupationArea}
        handleClose={handleClose}
      />
    </div>
  )
}

export default OccupationAreaConfig
